import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { RmV2MigratedState } from '../../generated/tenant-api';
import { trpc } from '../../utils/trpc';
import { LD_FLAG_RM_V2_MIGRATION } from '../../constants/featureFlags';
import { TenantType } from '../../lib/user/enums';
import useUser from '../../lib/useUser';
import { RmV2CompletedModal } from './RmV2CompletedModal';
import { RmV2PeerMigratedModal } from './RmV2PeerMigratedModal';

export const RmV2MigrationGate = ({ children }: { children: React.ReactNode }): JSX.Element => {
    const currentUser = useUser().user;
    const flags = useFlags();
    const flagOn = !!flags[LD_FLAG_RM_V2_MIGRATION];
    const isProvider = !!currentUser?.tenantTypes?.includes(TenantType.PROVIDER);

    const isTrueDatavanter = !!currentUser?.isTrueDatavanter;

    const { data, isLoading } = trpc.requestManager.getRmV2MigratedState.useQuery(undefined, {
        enabled: flagOn && isProvider && !isTrueDatavanter,
    });

    if (flagOn && isProvider && !isTrueDatavanter && !isLoading) {
        if (data?.rmV2MigratedState === RmV2MigratedState.COMPLETED) {
            return <RmV2CompletedModal />;
        }
        if (data?.rmV2MigratedState === RmV2MigratedState.PEER_MIGRATED) {
            return <RmV2PeerMigratedModal />;
        }
    }

    return <>{children}</>;
};
